module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/social/github-16a9304e38fd8167989291ab92544e14.svg";